/**
 * Same required-field rules as AdminEditUserPage student save.
 * @param {object} formData
 * @param {{ requireEnrollment?: boolean }} [options] — set false when staging enrollment is Skip
 * @returns {string|null}
 */
export function validateAdminEditUserForm(
  formData,
  { requireEnrollment = true, allowPartial = false } = {}
) {
  if (allowPartial) {
    const hasName =
      String(formData?.firstName || '').trim() ||
      String(formData?.lastName || '').trim() ||
      String(formData?.fullName || '').trim();
    if (!hasName) return 'A student name is required to save this row';
    const email = String(formData?.email || '').trim();
    if (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) return 'Please enter a valid email address';
    }
    if (requireEnrollment) {
      const missing = ['batchId', 'courseId', 'modeOfCourse'].filter((key) => {
        const val = formData?.[key];
        return val === undefined || val === null || (typeof val === 'string' && val.trim() === '');
      });
      if (missing.length) {
        return 'Please fill Batch, Course, and Mode when adding an enrollment';
      }
    }
    return null;
  }

  const requiredFields = [
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'mobile', label: 'Mobile' },
  ];

  const role = String(formData?.role || 'student').toLowerCase();
  if (role === 'student') {
    requiredFields.push({ key: 'veStudentId', label: 'VE Student ID' });
    if (requireEnrollment) {
      requiredFields.push({ key: 'batchId', label: 'Batch' });
      requiredFields.push({ key: 'courseId', label: 'Course' });
      requiredFields.push({ key: 'modeOfCourse', label: 'Mode (Online/Offline)' });
    }
  }

  const missingRequired = requiredFields.filter(({ key }) => {
    const val = formData?.[key];
    return val === undefined || val === null || (typeof val === 'string' && val.trim() === '');
  });
  if (missingRequired.length > 0) {
    return `Please fill all required fields. Missing: ${missingRequired
      .map(({ label }) => label)
      .join(', ')}`;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(String(formData?.email || '').trim())) {
    return 'Please enter a valid email address';
  }

  return null;
}
